{
  "es": {
    "published": {
      "labels": {
        "notPublished": "Sin publicar",
        "publishedCustomer": "Publicado para clientes",
        "publishedCustomerPartners": "Publicado para clientes y colaboradores",
        "publishedPartners": "Publicado para colaboradores"
      },
      "publish_mode": {
        "inherit": "Seguir la plantilla",
        "inherit_info": "Mantener el estado de publicación de cada elemento según la plantilla",
        "publish": "Publicar para los clientes",
        "publish_info": "Los clientes pueden verlos de inmediato",
        "title": "Publicación",
        "unpublished": "Crear sin publicar",
        "unpublished_info": "Ocultos para los clientes hasta que los publiques"
      }
    }
  }
}
